require("./m-form.scss");

require("iframe-resizer/js/iframeResizer.min.js");

iFrameResize({ log: true }, '.m-form__iframe');


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/molecule/m-form/m-form.chunk.js